/**
 * Whether the Rides fitness card is open (docs/RIDES_UX_PLAN.md §3.1):
 * the rider's choice, remembered on this device; until they choose, open
 * for the first 7 days after the card was first shown, then closed.
 */
import { useState } from 'react';
import { readStored, writeStored } from './useStoredChoice.ts';

export const FITNESS_EXPANDED_KEY = 'soigneur.fitnessExpanded';
export const FITNESS_FIRST_SEEN_KEY = 'soigneur.fitnessFirstSeen';
export const FITNESS_OPEN_MS = 7 * 24 * 60 * 60 * 1000;

export function initialFitnessExpanded(now: number = Date.now()): boolean {
  const chosen = readStored(FITNESS_EXPANDED_KEY);
  if (chosen === 'true' || chosen === 'false') return chosen === 'true';
  const firstSeen = Number(readStored(FITNESS_FIRST_SEEN_KEY));
  if (!Number.isFinite(firstSeen) || firstSeen <= 0) {
    writeStored(FITNESS_FIRST_SEEN_KEY, String(now));
    return true;
  }
  return now - firstSeen < FITNESS_OPEN_MS;
}

export function useFitnessExpanded(): [boolean, () => void] {
  const [expanded, setExpanded] = useState(() => initialFitnessExpanded());
  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    writeStored(FITNESS_EXPANDED_KEY, String(next));
  };
  return [expanded, toggle];
}
